<script setup></script>

<template>
    <dl class="space-y-2 sm:space-y-1">
        <slot />
    </dl>
</template>
